export const currentFolderAction = (type, folder) => {
    return{
        type: type,
        folder: folder
    }
}